import { render } from "./OpProfile.vue?vue&type=template&id=3157771f"
import script from "./OpProfile.vue?vue&type=script&lang=js"
export * from "./OpProfile.vue?vue&type=script&lang=js"

import "./OpProfile.vue?vue&type=style&index=0&id=3157771f&lang=css"

import exportComponent from "D:\\project\\idbrand\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__